import { COMMERCIAL_PROPERTY_TYPE_ID } from '../components/QaOrderReview/constants';

const formHeaders = {
  DELETE: 0,
  RESIDENTIAL_FULL: 7,
  PUBLIC_POOL: 10,
  FUEL_SALES: 12,
  COMMERCIAL_COOKING_CATERING: 14,
  WELDING: 19,
  COMMERCIAL_FARM: 20,
  PLAYGROUND: 31,
  GARAGE_AUTO_REPAIR: 32,
  GARAGE_AUTO_SALES: 33,
  ABOVE_GROUND_FUEL_STORAGE: 34,
  GAS_STATION: 35,
  MACHINE_SHOP: 39,
  MANUFACTURER: 40,
  COMMERCIAL_CONTRACTOR_LITE: 55,
  COMMERCIAL_CONTRACTOR_EXT: 56,
  COMMERCIAL_CONTRACTOR_PHONE: 57,
  COMMERCIAL_PRIMARY: 58,
  RESIDENTIAL_PRIMARY: 63,
  EXTERIOR_LITE: 64,
  COMMERCIAL_BUILDING_ELECTRIC_LITE: 70,
  LIQUOR_LIABILITY_FULL: 78,
  LIQUOR_LIABILITY_PHONE: 79,
  INTERIOR_STANDARD: 80,
  EXTERIOR_FULL: 81,
  CONDO_FULL: 83,
  OHIO_FAIR_PLAN: 84,
  WORKERS_COMPENSATION_FULL: 85,
  WORKERS_COMPENSATION_PHONE: 86,
  COMMERCIAL_CONTRACTOR_FULL: 87,
  COMMERCIAL_CONTRACTOR_PHONE: 88,
  RESIDENTIAL_POOL: 89,
  UTILITY_SURVEY_PHONE: 90,
  COASTAL_WIND_EXPOSURE: 91,
  PRODUCT_LIABILITY_FULL: 92,
  PRODUCT_LIABILITY_PHONE: 93,
  INTERIOR_BASIC: 94,
  COMMERCIAL_VEHICLE_FULL: 95,
  COMMERCIAL_VEHICLE_PHONE: 96,
  FARM_CONFINEMENT: 97,
  MOBILE_HOME: 98,
  ILLINOIS_FAIR_PLAN: 99,
  WILDFIRE_FULL: 100,
  QUICKVUE: 102,
  SKETCH: 103,
  RISKVUE_NO_RC: 105,
  OUTBUILDING: 107,
  ROOF_PITCH: 108,
  RISKVUE_RC_BASE: 110,
  E2V_LEVEL_1: 111,
  WILDFIRE_LITE: 112,
  COURSE_OF_CONSTRUCTION_FULL: 113,
  CORE_LOGIC_LEVEL_1: 114,
  HOVER_SKETCH: 115,
  RESIDENTIAL_PRIMARY_QV: 116,
  ROOF_SUPPLEMENT: 117,
  ISO_360_LEVEL_1: 118,
  AUSUM_PRIMARY: 119,
  AUSUM_VACANT_PROPERTY_REPORT: 120,
  RISKVUE_NO_RC_NO_ROOF: 121,
  // CORE_LOGIC_LEVEL_2: 122, // DEPRECATED -- USES 246 now
  E2V_LEVEL_2: 123,
  HOBBY_FARM: 124,
  LOSS_CONTROL_360_PRIMARY: 125,
  COMMERCIAL_ESSENTIALVUE: 126,
  COMMERCIAL_COOKING_SUPPLEMENT: 127,
  GARAGE_LIABILITY_SUPPLEMENT: 128,
  POOL_HOT_TUB_SUPPLEMENT: 129,
  SPRAY_PAINTING_SUPPLEMENT: 130,
  GASOLINE_SALES_SUPPLEMENT: 131,
  PLAYGROUND_SUPPLEMENT: 132,
  REPAIR_SHOP_WELDING_SUPPLEMENT: 133,
  ABOVE_GROUND_FUEL_STORAGE_SUPPLEMENT: 134,
  COMMERCIAL_NARRATIVES_OB: 135,
  COMMERCIAL_NARRATIVES: 254,
  COMMERCIAL_RISKVUE: 136,
  COMMERCIAL_ABR: 137,
  COMMERCIAL_ABRP: 140,
  COMMERCIAL_RC: 143,
  QUICKVUE_LITE: 144,
  CORE_LOGIC_LEVEL_1_NO_CALC: 145,
  CINCINNATI_HIGH_VALUE: 146,
  RISKVUE__E2V_L1_NO_CALCULATION: 147,
  E2V_L1_NO_CALC: 147,
  FLAMMABLE_LIQUID_STORAGE_SUPPLEMENT: 148,
  ELEVATOR_SUPPLEMENT: 149,
  LOSS_CONTROL_360_PRIMARY_WITH_COASTAL: 150,
  LOSS_CONTROL_360_PRIMARY_WITH_VIRTUAL: 151,
  LOSS_CONTROL_360_PRIMARY_WITH_INTERIOR_COMPREHENSIVE: 152,
  LOSS_CONTROL_360_PRIMARY_WITH_INTERIOR_STANDARD: 153,
  COMMERCIAL_AUTO_PHONE: 154,
  GL_CONTRACTOR_PHONE: 155,
  GL_SERVICE_PROVIDER_PHONE: 156,
  WORKERS_COMP_PHONE: 157,
  VEHICLE_RATING_SUPPLEMENT: 158,
  RISKVUE_L2_BASE: 159,
  L2_CORE_LOGIC_REPLACEMENT_COST: 164,
  L2_E2V_REPLACEMENT_COST: 167,
  LOSS_CONTROL_360_PRIMARY_WITH_GEO_SKETCH: 168,
  LOSS_CONTROL_360_PRIMARY_WITH_INTERIOR_STANDARD_AND_COASTAL: 169,
  JOB_SITE_SURVEY: 170,
  JOB_SITE_SUPPLEMENT: 171,
  COMMERCIAL_DWELLING: 172,
  E2V_LEVEL_1_OTHER_STRUCTURES_REPLACEMENT_COST: 191,
  UNDERWRITING_ACTION: 192,
  CIC_RCT_PERSONAL_LINES_RESIDENTIAL_FORM: 212,
  CIC_RCT_PERSONAL_LINES_RESIDENTIAL_FORM_VIRTUAL: 233,
  CIC_RCT_PERSONAL_LINES_RESIDENTIAL_FORM_EXTERIOR: 234,
  CIC_RCT_PERSONAL_LINES_RESIDENTIAL_FORM_EXTERIOR_B: 242,
  CIC_RCT_PERSONAL_LINES_VENDOR_HSR: 214,
  CIC_RCT_PERSONAL_LINES_VENDOR_HSR_EXTERIOR: 231,
  CIC_RCT_PERSONAL_LINES_VENDOR_HSR_VIRTUAL: 232,
  CIC_RCT_PERSONAL_LINES_EXTERIOR_RESIDENTIAL_FORM: 1121,
  CIC_RCT_PERSONAL_LINES_VIRTUAL_RESIDENTIAL_FORM: 1122,
  MOBILE_HOME: 237,
  MOBILE_HOME1: 238,
  CORE_LOGIC_LEVEL_2: 246,
  NOTES_TO_QA: 249,
};

export const VALUATION_FORM_HEADERS = [
  formHeaders.E2V_LEVEL_1,
  formHeaders.E2V_LEVEL_1_OTHER_STRUCTURES_REPLACEMENT_COST,
  formHeaders.CIC_RCT_PERSONAL_LINES_RESIDENTIAL_FORM,
  formHeaders.CIC_RCT_PERSONAL_LINES_RESIDENTIAL_FORM_VIRTUAL,
  formHeaders.CIC_RCT_PERSONAL_LINES_RESIDENTIAL_FORM_EXTERIOR,
  formHeaders.CIC_RCT_PERSONAL_LINES_RESIDENTIAL_FORM_EXTERIOR_B,
  formHeaders.CIC_RCT_PERSONAL_LINES_VENDOR_HSR,
  formHeaders.CIC_RCT_PERSONAL_LINES_VENDOR_HSR_EXTERIOR,
  formHeaders.CIC_RCT_PERSONAL_LINES_VENDOR_HSR_VIRTUAL,
  formHeaders.CIC_RCT_PERSONAL_LINES_EXTERIOR_RESIDENTIAL_FORM,
  formHeaders.E2V_LEVEL_2,
  formHeaders.CORE_LOGIC_LEVEL_1,
  formHeaders.CORE_LOGIC_LEVEL_1_NO_CALC,
  formHeaders.CORE_LOGIC_LEVEL_2,
  formHeaders.ISO_360_LEVEL_1,
  formHeaders.MOBILE_HOME,
  formHeaders.MOBILE_HOME1,
];

export const VALUATION_FORM_HEADERS_WITH_BUTTON = [
  formHeaders.E2V_LEVEL_1,
  formHeaders.E2V_LEVEL_1_OTHER_STRUCTURES_REPLACEMENT_COST,

  formHeaders.CORE_LOGIC_LEVEL_1,
  formHeaders.ISO_360_LEVEL_1,
  formHeaders.MOBILE_HOME,
  formHeaders.MOBILE_HOME1,
];

export const ausumOrLc360FormHeaderIds = [
  formHeaders.AUSUM_PRIMARY,
  formHeaders.AUSUM_VACANT_PROPERTY_REPORT,
  formHeaders.LOSS_CONTROL_360_PRIMARY,
  formHeaders.LOSS_CONTROL_360_PRIMARY_WITH_COASTAL,
  formHeaders.LOSS_CONTROL_360_PRIMARY_WITH_VIRTUAL,
  formHeaders.LOSS_CONTROL_360_PRIMARY_WITH_INTERIOR_COMPREHENSIVE,
  formHeaders.LOSS_CONTROL_360_PRIMARY_WITH_INTERIOR_STANDARD,
  formHeaders.LOSS_CONTROL_360_PRIMARY_WITH_GEO_SKETCH,
  formHeaders.LOSS_CONTROL_360_PRIMARY_WITH_INTERIOR_STANDARD_AND_COASTAL,
];

export const checkIfAusumOrLc360 = (formHeaders = []) => {
  return !!formHeaders.find(fh => ausumOrLc360FormHeaderIds.includes(fh.formHeaderId));
};

export const checkIfRCT = (orderForms = []) => {
  return !!orderForms.find(of => [true].includes(of.isRCT));
};

export const checkOrderRecommendationsRequirement = (formHeadersForOrder = []) => {
  return !!formHeadersForOrder.some(
    fh =>
      fh.propertyTypeId === COMMERCIAL_PROPERTY_TYPE_ID || [formHeaders.COMMERCIAL_DWELLING].includes(fh.formHeaderId),
  );
};

export const getAusumOrLc360Links = formHeaders => {};

export default formHeaders;
